import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../css/Header.css";

export default function PavanSpeech({ links }) {
  return (
    <Container>
      <Row>
        <Col className="pavanspeech">
          <p>
          Pavan Agarwal, our CEO, spoke about how Sun West's exclusive{" "}
            <a href={links.mobileAppURL} target="_blank">
              {links.brandName}
            </a>{" "}
            and Instant Underwriting&trade; can help you save time and money, which you can instead use to double your business.
            <br />
            <br />
            We had a great turnout at our booth with people wanting to meet
            integral members of Sun West and learn how our technology takes care
            of the clerical work (following up, condition reviews, DU/LP, and
            much more) so that they can spend their time marketing, sourcing,
            and harvesting new relationships.
          </p>
        </Col>
      </Row>
    </Container>
  );
}
